module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Account Credit - " + _vm._s(_vm.accountCredit))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-172646c4"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/AccountCredit.vue
// module id = 940
// module chunks = 0